import { render, staticRenderFns } from "./EditServiceAgreementDialog.vue?vue&type=template&id=5bca3462&scoped=true&"
import script from "./EditServiceAgreementDialog.vue?vue&type=script&lang=js&"
export * from "./EditServiceAgreementDialog.vue?vue&type=script&lang=js&"
import style0 from "./EditServiceAgreementDialog.vue?vue&type=style&index=0&id=5bca3462&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bca3462",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCheckbox,VCol,VContainer,VForm,VRow,VSelect,VTextField})
